var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"navbar"},[_c('div',{staticClass:"container"},[_c('figure',[_c('img',{attrs:{"src":require("../assets/img/logo.svg")}})])])])}]

export { render, staticRenderFns }